import React from 'react';
import {useNavigate} from 'react-router-dom';

function ExternalLink({href, children, className = ''}) {
  return (
    <a
      href={href}
      target='_blank'
      rel='noreferrer'
      className={className}>
      {children}
    </a>
  );
}

export default function NewsList({
  items,
  imageMap,
  mode = 'cards', // "cards" for homepage section, "full" for /news page
  className = '',
}) {
  const navigate = useNavigate();

  if (!items?.length) return null;

  if (mode === 'cards') {
    return (
      <div
        className={`row m-auto newsCardContainer justify-content-md-center ${className}`}>
        {items.map((item) => (
          <div
            className='col-12 col-lg-4 pt-3 pt-lg-0'
            key={item.id}>
            <div className='cards p-2'>
              {item.imageKey && (
                <img
                  src={imageMap[item.imageKey]}
                  alt={item.title}
                  className='img-fluid d-block mx-auto px-2 mb-3'
                />
              )}

              <p className='pt-2 cardtext'>{item.title}</p>

              {item.variant === 'links' &&
                item.links?.map((l) => (
                  <div
                    key={l.url}
                    className='mt-2'>
                    <ExternalLink
                      href={l.url}
                      className='linkLightBase'>
                      {l.label.includes('Order') ? (
                        <>
                          Click <u>here</u> to {l.label}
                        </>
                      ) : (
                        <>
                          <u>{l.label}</u>
                        </>
                      )}
                    </ExternalLink>
                  </div>
                ))}

              {item.variant === 'link' && item.link && (
                <div className='mt-2'>
                  <ExternalLink
                    href={item.link.url}
                    className='linkLightBase'>
                    {item.link.label} <u>here</u>
                  </ExternalLink>
                </div>
              )}

              {item.variant === 'cta' && item.cta && (
                <p className='mt-2 mb-0'>
                  <button
                    onClick={() => navigate(item.cta.to)}
                    className='btnDarkLight px-3 py-1'>
                    {item.cta.label} <u>here</u>
                  </button>
                </p>
              )}

              {item.variant === 'imageOnly' && item.imageLinkKey && (
                <div className='canadaimagecontainer'>
                  <ExternalLink
                    href={imageMap[item.imageLinkKey]}
                    className='linkLightBase'>
                    <p className='mb-3 canadaenlarge'>click to enlarge</p>
                  </ExternalLink>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // mode === "full"
  return (
    <div className={className}>
      {items.map((item) => (
        <React.Fragment key={item.id}>
          <div className='row m-auto p-1 p-sm-3 align-items-center news'>
            <div className='col-12 col-md-6 text-center text-md-end'>
              {item.imageKey && (
                <img
                  src={imageMap[item.imageKey]}
                  alt={item.title}
                  className='w-50 img-fluid middleimage'
                />
              )}
            </div>

            <div className='col-12 col-md-6 text-center text-md-start'>
              <p className='mt-3 mb-0'>{item.title}</p>

              {item.variant === 'links' &&
                item.links?.map((l) => (
                  <div
                    className='mt-3'
                    key={l.url}>
                    <ExternalLink
                      href={l.url}
                      className='linkLightBase'>
                      {l.label}
                    </ExternalLink>
                  </div>
                ))}

              {item.variant === 'link' && item.link && (
                <div className='mt-3'>
                  <ExternalLink
                    href={item.link.url}
                    className='linkLightBase'>
                    {item.link.label}
                  </ExternalLink>
                </div>
              )}

              {item.variant === 'cta' && item.cta && (
                <p className='mt-2 mb-0'>
                  <button
                    onClick={() => navigate(item.cta.to)}
                    className='btnDarkLight px-3 py-1'>
                    {item.cta.label} <u>here</u>
                  </button>
                </p>
              )}

              {item.variant === 'imageOnly' && item.imageLinkKey && (
                <div className='canadaimagecontainer'>
                  <ExternalLink
                    href={imageMap[item.imageLinkKey]}
                    className='linkLightBase'>
                    <p className='mb-3 canadaenlarge left'>click to enlarge</p>
                  </ExternalLink>
                </div>
              )}
            </div>
          </div>
          <hr />
        </React.Fragment>
      ))}
    </div>
  );
}
